import { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { FaPhoneAlt, FaWhatsapp, FaEnvelope, FaGlobe, FaInstagram } from "react-icons/fa";
import { db } from "../Firebase";
import emailjs from "@emailjs/browser";

export default function Contact() {

    const [form, setForm] = useState({
        name: "",
        phone: "",
        email: "",
        age: "",
        weight: "",
        goal: "",
        program: "",
        message: ""
    });

    const [pro, setpro] = useState([]);

    function fetchprograms() {
        db.collection("programs").onSnapshot((succ) => {
            setpro(succ.docs);
        })
    }

    useEffect(() => {
        fetchprograms()
    }, [])

    function handleChange(e) {
        const { name, value } = e.target;
        if (name === "goal") {
            setForm({
                ...form,
                goal: value,
                message: goalMessages[value] || ""
            });
        } else {
            setForm({
                ...form,
                [name]: value
            });
        }
    }

    function handleSubmit(e) {
        e.preventDefault();
        var data = new FormData(e.currentTarget);
        var name = data.get("name");
        var phone = data.get("phone");
        var email = data.get("email");
        var age = data.get("age");
        var weight = data.get("weight");
        var goal = data.get("goal");
        var program = data.get("program");
        var message = data.get("message");
        var status = "Pending";
        var date = new Date().toLocaleString()

        db.collection("form").add({
            name: name,
            phone: phone,
            email: email,
            age: age,
            weight: weight,
            goal: goal,
            program: program,
            message: message,
            status: status,
            date: date
        }).then((succ) => {
            emailjs.send(
                "service_4xh9oku",
                "template_lb80sbn",
                {
                    name: name,
                    phone: phone,
                    email: email,
                    age: age,
                    weight: weight,
                    goal: goal,
                    program: program,
                    message: message,
                    status: status,
                    date: date
                },
                "njakfRHWmZdWbtc9n"
            );
        }).then((succ) => {
            alert("Enquiry Submitted Successfully!");
            setForm({
                name: "",
                phone: "",
                email: "",
                age: "",
                weight: "",
                goal: "",
                program: "",
                message: ""
            });
        })
    }

    const faqs = [
        { q: "How does online coaching work?", a: "You receive personalized workout and nutrition plans with regular check-ins." },
        { q: "Can beginners join?", a: "Absolutely. Programs are customized for all fitness levels." },
        { q: "How often do we communicate?", a: "Weekly check-ins and support during working hours." },
        { q: "Do I need supplements?", a: "No. Supplements are optional and based on your goals." }
    ];

    const goalMessages = {
        "Fat Loss": "I want to lose weight and reduce body fat. Please guide me on the best program for my fitness goals.",
        "Muscle Gain": "I want to build muscle and increase strength. Please recommend the most suitable coaching plan.",
        "Body Recomposition": "I want to lose fat while building lean muscle. Please help me choose the right program.",
        "Nutrition Coaching": "I need guidance with nutrition and meal planning. Please provide details about your coaching.",
        "General Fitness": "I want to improve my overall fitness, health, and lifestyle. Please suggest the best coaching option."
    };

    return (
        <>
            <title>Contact Us | The Fitness Expert - Book Your Free Fitness Consultation</title>
            <meta name="description" content="Get in touch with The Fitness Expert for personalized fitness coaching, fat loss programs, muscle building plans, nutrition guidance, and online personal training. Book your free consultation today." />
            <meta name="keywords" content="contact The Fitness Expert, fitness coach contact, online fitness consultation, book fitness coach, personal trainer contact, fat loss consultation, muscle building coach, nutrition coaching, online personal training, fitness expert India, free fitness consultation, health coach contact" />
            <meta property="og:title" content="Contact The Fitness Expert | Book Your Free Consultation" />
            <meta property="og:site_name" content="The Fitness Expert" />
            <meta property="og:url" content="https://fitnesssappp.web.app/user/Contact" />
            <meta property="og:description" content="Ready to transform your body? Contact The Fitness Expert today for personalized fitness coaching, workout plans, nutrition guidance, and a free consultation." />

            <meta property="og:image" content="logoo.png"></meta>

            <meta name="twitter:card" content="app" />
            <meta name="twitter:site" content="@thefitnessexpert" />
            <meta name="twitter:description" content="Ready to transform your body? Contact The Fitness Expert today for personalized fitness coaching, workout plans, nutrition guidance, and a free consultation." />
            <meta name="twitter:app:country" content="India" />
            <Navbar />
            <section className="contactHero py-5 overflow-hidden">
                <div className="container">
                    <div className="row align-items-center g-5">
                        <div className="col-lg-6">
                            <div className="heroLine mb-3">
                                <span></span>
                                <small>CONTACT COACH</small>
                            </div>
                            <h1 className="display-5 fw-bold text-white">
                                Let's Build Your
                                <br />
                                <span className="text-danger">
                                    Transformation
                                </span>
                                <br />
                                Plan Together
                            </h1>
                            <p className="text-light opacity-75 text-lead mt-4 mb-4">
                                Whether your goal is fat loss, muscle building or
                                improving your overall fitness, let's create a
                                personalized roadmap designed specifically for you.
                            </p>
                            <div className="d-flex flex-wrap gap-3">
                                <button
                                    className="btn btn-danger btn-lg px-4 rounded-3"
                                    onClick={() =>
                                        window.open(
                                            "https://wa.me/919876857579",
                                            "_blank"
                                        )
                                    }
                                >
                                    💬 WhatsApp Now
                                </button>
                                <button className="btn btn-outline-light btn-lg px-4 rounded-3">
                                    📅 Book Consultation
                                </button>
                            </div>
                            <div className="row g-3 mt-3">
                                <div className="col-md-4 col-4">
                                    <div className="heroStat">
                                        <h3 className="text-light">500+</h3>
                                        <p>Happy Clients</p>
                                    </div>
                                </div>
                                <div className="col-md-4 col-4">
                                    <div className="heroStat">
                                        <h3 className="text-light">15+</h3>
                                        <p>Years Experience</p>
                                    </div>
                                </div>
                                <div className="col-md-4 col-4">
                                    <div className="heroStat">
                                        <h3 className="text-light">95%</h3>
                                        <p>Success Rate</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="coachWrapper">
                                <img src="../images/coach.jpeg" className="img-fluid coachImg" />
                                <div className="quoteCard">
                                    <h5>
                                        Your goals.
                                        My expertise.
                                    </h5>
                                    <h3 className="fw-bold">Unstoppable Results.</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section className="py-5 bg-light">
                <div className="container">
                    <div className="row g-4">
                        <div className="col-lg-3 col-md-6">
                            <div onClick={() => window.location.href = "tel:+919876857579"} className="cur card border-0 shadow-sm text-center p-4 h-100">
                                <div className="text-danger fs-1 mb-3"><FaPhoneAlt /></div>
                                <h5 className="fw-bold">Call Us</h5>
                                <p className="text-muted mb-0">+91 98768 57579</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="card border-0 shadow-sm text-center p-4 h-100 cur"
                                onClick={() =>
                                    window.open("https://wa.me/919876857579?text=Hello%20Harman%20Sir%20👋%0A%0AI%20visited%20your%20website%20and%20I'm%20interested%20in%20your%20fitness%20coaching%20programs.", "_blank"
                                    )}>
                                <div className="text-danger fs-1 mb-3"><FaWhatsapp /></div>
                                <h5 className="fw-bold">WhatsApp</h5>
                                <p className="text-muted mb-0">Chat Directly</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="card border-0 shadow-sm text-center p-4 h-100 cur"
                                onClick={() =>
                                    window.open(
                                        "https://mail.google.com/mail/?view=cm&fs=1&to=harmanverma5692@gmail.com",
                                        "_blank"
                                    )}>
                                <div className="text-danger fs-1 mb-3"><FaEnvelope /></div>
                                <h5 className="fw-bold">Email</h5>
                                <p className="text-muted mb-0">harmanverma5692@gmail.com</p>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="card border-0 shadow-sm text-center p-4 h-100">
                                <div className="text-danger fs-1 mb-3"><FaGlobe /></div>
                                <h5 className="fw-bold">Location</h5>
                                <p className="text-muted mb-0">Online Worldwide</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="py-5">
                <div className="container">
                    <div className="row align-items-center g-5">
                        <div className="col-lg-5">
                            <span className="text-danger fw-bold">GET IN TOUCH</span>
                            <h2 className="fw-bold mb-3">Start Your Fitness Journey Today</h2>
                            <p className="text-muted">Tell us about your goals and we'll recommend the best coaching program for you.</p>
                            <img src="https://cdn-icons-png.flaticon.com/512/1048/1048953.png" alt="" className="img-fluid mt-4" />
                        </div>
                        <div className="col-lg-7">
                            <div className="card border-0 shadow p-4">
                                <form onSubmit={handleSubmit}>
                                    <div className="row g-3">
                                        <div className="col-md-6">
                                            <input required type="text" className="form-control" placeholder="Full Name" name="name" value={form.name} onChange={handleChange} />
                                        </div>
                                        <div className="col-md-6">
                                            <input required type="text" className="form-control" placeholder="Phone Number" name="phone" value={form.phone} onChange={handleChange} />
                                        </div>
                                        <div className="col-md-6">
                                            <input required type="email" className="form-control" placeholder="Email Address" name="email" value={form.email} onChange={handleChange} />
                                        </div>
                                        <div className="col-md-3">
                                            <input required type="number" className="form-control" placeholder="Age" name="age" value={form.age} onChange={handleChange} />
                                        </div>
                                        <div className="col-md-3">
                                            <input required type="number" className="form-control" placeholder="Weight" name="weight" value={form.weight} onChange={handleChange} />
                                        </div>
                                        <div className="col-md-6">
                                            <select required value={form.goal} className="form-select" name="goal" onChange={handleChange}>
                                                <option value="">Select Goal</option>
                                                <option value="Fat Loss">Fat Loss</option>
                                                <option value="Muscle Gain">Muscle Gain</option>
                                                <option value="Body Recomposition">Body Recomposition</option>
                                                <option value="Nutrition Coaching">Nutrition Coaching</option>
                                                <option value="General Fitness">General Fitness</option>
                                            </select>
                                        </div>
                                        <div className="col-md-6">
                                            <select required className="form-select" name="program" onChange={handleChange} value={form.program}>
                                                <option value="">Select Program</option>
                                                {pro.map((row) => (
                                                    <option key={row.id} value={row.data().name}>{row.data().icon} {row.data().name}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-12">
                                            <textarea required rows="5" className="form-control" placeholder="Your message will appear here..." value={form.message} name="message" onChange={handleChange} />
                                        </div>
                                        <div className="col-12">
                                            <button className="btn btn-danger w-100 py-3">
                                                Request Consultation
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="bg-dark text-white py-5">
                <div className="container text-center">
                    <h2 className="fw-bold">Not Sure Which Program Is Right?</h2>
                    <button className="btn btn-danger btn-md mt-2" onClick={() => window.location.href = "tel:+919876857579"}>Schedule Call</button>
                </div>
            </section>
            <section className="py-5 bg-light">
                <div className="container">
                    <h2 className="text-center fw-bold mb-5">Frequently Asked Questions</h2>
                    <div className="accordion" id="faqAccordion">
                        {faqs.map((faq, index) => (
                            <div className="accordion-item" key={index}>
                                <h2 className="accordion-header">
                                    <button className={`accordion-button ${index !== 0 ? "collapsed" : ""}`} type="button" data-bs-toggle="collapse" data-bs-target={`#faq${index}`}>
                                        {faq.q}
                                    </button>
                                </h2>
                                <div id={`faq${index}`} className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}>
                                    <div className="accordion-body">{faq.a}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <div className="position-fixed bottom-0 end-0 p-3 z-3">
                <button className="fixed-join-btn text-light fw-bold px-3 py-2 shadow rounded-pill bgcolor"
                    onClick={() =>
                        window.open("https://wa.me/919876857579?text=Hello%20Harman%20Sir%20👋%0A%0AI%20visited%20your%20website%20and%20I'm%20interested%20in%20your%20fitness%20coaching%20programs.", "_blank"
                        )}>
                    <FaWhatsapp size={24} />
                </button>
            </div>
            <Footer />
        </>
    );
}